import { Divider } from '@material-ui/core';
import { Button, Modal, Typography } from '@thingsw/pitta-design-system';
import { LightColors, BlackvueLightColors } from '@thingsw/pitta-modules';
import React from 'react';
import { useTranslation } from 'react-i18next';

export interface BlackvueAppUseOnlyModalProps {
  open: boolean;
  onLogout: () => void;
}

const BlackvueAppUseOnlyModal = ({
  open,
  onLogout,
}: BlackvueAppUseOnlyModalProps) => {
  const { t } = useTranslation();
  return (
    <Modal
      open={open}
      onClose={onLogout}
      content={
        <>
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              gap: 8,
              marginBottom: 16,
            }}
          >
            <Typography category='Default' variant='H6'>
              {t('BlackVue App Use Only')}
            </Typography>
            <Typography category='Default' variant='Body'>
              {t('Your current plan allow_')}
            </Typography>
            <a
              href='https://fleeta.io/features'
              target='_blank'
              rel='noreferrer'
              style={{
                display: 'flex',
                gap: 8,
                alignItems: 'center',
                cursor: 'pointer',
              }}
            >
              <Typography
                category='Default'
                variant='Body'
                htmlColor={BlackvueLightColors.primary['7']}
              >
                {t('Learn more about the Fleet_')}
              </Typography>
              <svg
                width='16'
                height='16'
                viewBox='0 0 16 16'
                fill='none'
                xmlns='http://www.w3.org/2000/svg'
              >
                <path
                  d='M9.67969 0.5H15.5V6.32031H13.8203V3.35156L5.65625 11.5156L4.48438 10.3438L12.6484 2.17969H9.67969V0.5ZM13.8203 13.8203V8H15.5V13.8203C15.5 14.263 15.3307 14.6536 14.9922 14.9922C14.6536 15.3307 14.263 15.5 13.8203 15.5H2.17969C1.71094 15.5 1.30729 15.3438 0.96875 15.0312C0.65625 14.6927 0.5 14.2891 0.5 13.8203V2.17969C0.5 1.71094 0.65625 1.32031 0.96875 1.00781C1.30729 0.669271 1.71094 0.5 2.17969 0.5H8V2.17969H2.17969V13.8203H13.8203Z'
                  fill='#0095E0'
                />
              </svg>
            </a>
            {/* 프로모션 기간 중에만 출력 시작 */}
            <Divider />
            <div>
              <Typography
                category='Default'
                variant='BodyBold'
                style={{
                  marginLeft: 4,
                  marginBottom: 8,
                  display: 'block',
                }}
              >
                {t('Special Offer')}
              </Typography>
              <div
                style={{
                  borderRadius: 12,
                  border: `1px solid ${LightColors.primary['9']}`,
                  backgroundColor: LightColors.primary['10'],
                  padding: 12,
                  display: 'flex',
                  flexDirection: 'column',
                  gap: 8,
                }}
              >
                <Typography category='Default' variant='Body'>
                  {t('For a limited time_')}
                </Typography>
                <a
                  href='https://media.blackvue.com/blackvue-cloud-upgrade-to-fleet-plan-for-the-price-of-smart-unlock-fleeta-access/'
                  target='_blank'
                  rel='noreferrer'
                >
                  <Typography
                    category='Default'
                    variant='Body'
                    htmlColor={BlackvueLightColors.primary['7']}
                  >
                    {t('See Discount Details')}
                  </Typography>
                </a>
              </div>
            </div>
            {/* 프로모션 기간 중에만 출력 끝 */}
            <Typography
              category='Default'
              variant='Small'
              htmlColor={LightColors.primary['3']}
            >
              {t('To subscribe to the Fleet_')}
            </Typography>
          </div>
          <div
            style={{
              display: 'flex',
              justifyContent: 'end',
            }}
          >
            <Button onClick={onLogout} color='primary'>
              {t('OK')}
            </Button>
          </div>
        </>
      }
    />
  );
};

export default BlackvueAppUseOnlyModal;
